(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    function readyProductPreviews(root=document){
  root.querySelectorAll('.product-image-secondary').forEach(image=>{if(image.complete&&image.naturalWidth)image.closest('.product')?.setAttribute('data-secondary-ready','true')});
}
document.addEventListener('load',event=>{const image=event.target;if(image.matches?.('.product-image-secondary')&&image.naturalWidth)image.closest('.product')?.setAttribute('data-secondary-ready','true')},true);
readyProductPreviews();
document.addEventListener('shopify:section:load',event=>readyProductPreviews(event.target));
  } catch(e) { console.error(e); }
})();

})();
